import { startOfDay } from 'date-fns'
import type React from 'react'

import { type BrokersEnrollmentWithPaymentsOrCoverages } from 'utils/web_api.schemas'

export const formatAmount = (value: string): string => {
  // Remove any non-digit characters
  let numericValue = value.replace(/\D/g, '')

  // Prevent leading zeros from causing issues
  numericValue = numericValue.replace(/^0+/, '')

  // Format the number
  if (numericValue.length === 0) {
    return '0.00'
  } else if (numericValue.length === 1) {
    return `0.0${numericValue}`
  } else if (numericValue.length === 2) {
    return `0.${numericValue}`
  }

  return `${numericValue.slice(0, -2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${numericValue.slice(-2)}`
}

export const handleAmountChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  setAmount: React.Dispatch<React.SetStateAction<string>>,
  maxAmount?: number
) => {
  const value = e.target.value
  const formattedValue = formatAmount(value)

  if (maxAmount) {
    return setAmount(maxAmount < parseFloat(formattedValue.replace(/,/g, '')) ? Number(maxAmount).toFixed(2) : formattedValue)
  }
  return setAmount(formattedValue)
}

/**
 * NOTE: This function does duplicate logic to what we do in <app/models/insurance/enrollment.rb>
 * If that method ever diverges from implementation to this one below,
 * then this should be updated or refactored.
 */
export const checkIfEnrollmentIsReimbursementOnly = (enrollment: BrokersEnrollmentWithPaymentsOrCoverages, transactionDate: string) => {
  if (enrollment.reimbursement_only_at && startOfDay(new Date(transactionDate)) >= startOfDay(new Date(enrollment.reimbursement_only_at))) {
    return true
  }
  return false
}
